import React from 'react'

const OurPurpose = () => {
    
    return (
        <section id="homePage_our_purpose"
            className="grid gtc12 mb4-00"
        >
            <div className="gc1s12 gr1s1"
            >
                <figcaption className="pa1-00 pa4-00-m gc1s1 gr1s1 
                    container container90 
                    tc fw6 black 
                    bg-black-20"
                >
                    <h1 className="f3-00 f4-00-m  fw6 ttc mt0-00 mb2-00">
                        Our Purpose
                    </h1>
                    <p className="f1-75 mb2-00">
                        To design develop and deliver custom digital solutions for forward looking individuals, businesses and organizations.
                    </p>
                    {/* <p className="f1-75 mb0-00">
                        We are committed to providing our clients with the highest quality services and products that meet their unique needs and exceed their expectations
                    </p> */}
                </figcaption>
            </div>
        </section>
    )
}

export default OurPurpose